export const PRICE_GRID_MARKET_DATA_COLUMN_DYNAMICS_SPEC = 'price-grid-market-data';
export const PRICE_GRID_LEG_MARKET_DATA_COLUMN_DYNAMICS_SPEC = 'price-grid-leg-market-data';
